import { TFunction } from 'i18next';

import { KPI_GROUPS, KpiUnit } from '@/shared/types/kpi';

// Utility functions that don't use hooks - can be called inside JSX
export const getKpiUnitTranslation = (
  t: TFunction<'kpiTypes'>,
  unit: string | KpiUnit | null,
): string => {
  let value: KpiUnit;
  if (!unit) {
    return '-';
  }
  if (unit instanceof KpiUnit) {
    value = unit;
  } else {
    value = KpiUnit.fromString(unit);
  }
  return t(`units.${value.code}`, { defaultValue: value.code });
};

export const getKpiUnitAbbreviationTranslation = (
  t: TFunction<'kpiTypes'>,
  unit: string | KpiUnit | null,
): string => {
  let value: KpiUnit;
  if (!unit) {
    return '-';
  }
  if (unit instanceof KpiUnit) {
    value = unit;
  } else {
    value = KpiUnit.fromString(unit);
  }
  return t(`units_abbreviations.${value.group}.${value.code}`, {
    defaultValue: value.code,
  });
};

/**
 * Gets the KPI unit translation in plural form for the context "in [unit]"
 * Example: "in Stunden", "in Euro", "in Stück"
 */
export const getKpiUnitTranslationPlural = (
  t: TFunction<'kpiTypes'>,
  unit: string | KpiUnit | null,
): string => {
  let value: KpiUnit;
  if (!unit) {
    return '';
  }
  if (unit instanceof KpiUnit) {
    value = unit;
  } else {
    value = KpiUnit.fromString(unit);
  }

  // Try to get the plural form first, fallback to singular
  return (
    t('units_translation_prefix') +
    ' ' +
    t(`units_plural.${value.code}`, {
      defaultValue: t(`units.${value.code}`, { defaultValue: value.code }),
    })
  );
};

export const getKpiGroupTranslation = (
  t: TFunction<'kpiTypes'>,
  group: keyof typeof KPI_GROUPS | string,
): string => {
  return t(`kpi_groups.${group}`, { defaultValue: group });
};
